import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Pulldown } from 'jbc-front/components/icons';
import { TextField, Label } from 'src/jbc-front/components/Form';

import MoneyFieldMockup from './MoneyFieldMockup';

import styles from './EmployeePayForm.scss';

const DeductionsSectionMockup = ({ fields, isViewOnly, name, greenTextList }) => {
  const { t } = useTranslation();
  const [expandStates, setExpandStates] = useState({});
  const toggleExpand = itemId => {
    setExpandStates(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };
  const isExpanded = itemId => expandStates[itemId] || false;

  const recalculationHint = t('features.EmployeePays.components.DeductionsSectionMockup.recalculation_hint');

  return (
    <tbody>
      {fields.map((field, index) => (
        <React.Fragment key={`ps.${index + 1}`}>
          <tr className={classNames({ [styles.total]: field.isTotal })}>
            <th>
              {field.label}
              {field.description && (
                <Pulldown size={18} className={isExpanded(field.id) ? styles.expandIconOpen : styles.expandIconClose} onClick={() => toggleExpand(field.id)} />
              )}
            </th>
            <td className={styles.value}>
              {isViewOnly || field.isTotal || field.disabled ? (
                <MoneyFieldMockup greenTextList={greenTextList} title={field.label} value={field.value} description={field.description} />
              ) : (
                <TextField name={`${name}[${index}].value`} textAlign="right" />
              )}
              {field.isHint && !isViewOnly && <Label note={recalculationHint} />}
            </td>
          </tr>
          {isExpanded(field.id) &&
            field.description &&
            field.description.map((childField, childIdx) => (
              <tr key={childField.id}>
                <th style={{ paddingLeft: '30px' }}>{childField.label}</th>
                <td className={styles.value}>
                  {isViewOnly && field.disabled ? (
                    <MoneyFieldMockup greenTextList={greenTextList} title={childField.label} value={childField.value} />
                  ) : (
                    <TextField name={`${name}[${index}].description[${childIdx}].value`} textAlign="right" />
                  )}
                  {childField.isHint && !isViewOnly && <Label note={recalculationHint} />}
                </td>
              </tr>
            ))}
        </React.Fragment>
      ))}
    </tbody>
  );
};

export default DeductionsSectionMockup;
